import { IButton } from '../interfaces';
import { Button } from '../components';
import React from 'react';
import { getSubtitlesVisible } from '../config/runtimeConfig';

interface Props {
    title: string;
    subtitle?: string;
    buttons?: IButton[];
}

const Header: React.FC<Props> = ({ title, subtitle, buttons }) => {
    const subtitleVisible: boolean = getSubtitlesVisible();

    return (
        <div className="ac-page-header">
            <div className="min-w-0">
                <h2 className="ac-page-title">{title}</h2>
                {subtitleVisible && subtitle ? (
                    <p className="jo-body-muted mt-1 text-sm font-medium">{subtitle}</p>
                ) : null}
            </div>

            {buttons && buttons.length > 0 ? (
                <div className="flex flex-wrap items-center gap-2">
                    {buttons.map((button, index) => (
                        <div key={index} title={button.title}>
                            <Button {...button} />
                        </div>
                    ))}
                </div>
            ) : null}
        </div>
    );
};

export default Header;
